import axiosInstance from "@/utils/axiosInstance";
import { formatWorkflowActionLabel as formatSemanticWorkflowActionLabel } from "@/utils/semanticLabels";

export interface AvailableAction {
  action_code: string;
  to_status: string;
}

export interface AvailableActionsResponse {
  submission_id: number;
  current_state: string | null;
  actions: AvailableAction[];
}

export interface WorkflowTimelineEvent {
  id: number;
  from_status: string;
  to_status: string;
  action_code: string;
  actor_id: number;
  actor_role: string;
  reason_code?: string | null;
  reason_text?: string | null;
  workflow_config_id: number;
  timestamp: string;
}

export interface AuditMarker {
  id: number;
  actor_id?: number | null;
  actor_role?: string | null;
  action: string;
  from_state?: string | null;
  to_state?: string | null;
  remarks?: string | null;
  system_generated: boolean;
  timestamp: string;
}

export interface AssignmentTimelineEvent {
  id: number;
  assigned_to_user_id: number;
  assigned_by_user_id?: number | null;
  role_context: string;
  reason?: string | null;
  assignment_source: string;
  routing_reason?: string | null;
  routing_rule_version?: string | null;
  assigned_at: string;
  unassigned_at?: string | null;
}

export interface SubmissionTimelineResponse {
  submission_id: number;
  workflow_events: WorkflowTimelineEvent[];
  assignment_events: AssignmentTimelineEvent[];
  audit_markers: AuditMarker[];
}

export async function fetchAvailableActions(
  submissionId: number
): Promise<AvailableActionsResponse> {
  const res = await axiosInstance.get<AvailableActionsResponse>(
    `/workflow/available-actions/${submissionId}`
  );
  return res.data;
}

export async function fetchSubmissionTimeline(
  submissionId: number
): Promise<SubmissionTimelineResponse> {
  const res = await axiosInstance.get<SubmissionTimelineResponse>(
    `/submissions/${submissionId}/timeline`
  );
  return res.data;
}

export function formatWorkflowActionLabel(code: string): string {
  return formatSemanticWorkflowActionLabel(code);
}
